import PropTypes from 'prop-types';
import React from 'react';

import { Spin } from '../../../../../styles/global';
import {
  Container,
  Divisor,
  LoadingContainer,
  Totalizador,
  TotalizadorNome,
  TotalizadorNum,
} from './styles';

const Totalizadores = ({ totalizadores, loading }) => (
  <Container>
    {loading || !totalizadores ? (
      <Spin style={{ width: '100%', margin: '50px 0' }} />
    ) : (
      <>
        <Totalizador backgroundColor="#FFF2EE" textColor="#8A5E50">
          <TotalizadorNum>
            {totalizadores.totalAguardandoAprovacao}
          </TotalizadorNum>
          <Divisor borderColor="#8A5E50" />
          <TotalizadorNome>Aguardando aprovação</TotalizadorNome>
        </Totalizador>
        <Totalizador backgroundColor="#F9F0FF" textColor="#531DAB">
          <TotalizadorNum>{totalizadores.totalEmTransito}</TotalizadorNum>
          <Divisor borderColor="#531DAB" />
          <TotalizadorNome>Em trânsito</TotalizadorNome>
        </Totalizador>
        <Totalizador backgroundColor="#FFFBE6" textColor="#AD6800">
          <TotalizadorNum>{totalizadores.totalNaFila}</TotalizadorNum>
          <Divisor borderColor="#AD6800" />
          <TotalizadorNome>Na fila</TotalizadorNome>
        </Totalizador>
        <Totalizador backgroundColor="#E6F7FF" textColor="#0050B3">
          <TotalizadorNum>{totalizadores.totalEmbarcados}</TotalizadorNum>
          <Divisor borderColor="#0050B3" />
          <TotalizadorNome>Embarcado</TotalizadorNome>
        </Totalizador>
        <Totalizador backgroundColor="#EEFFF6" textColor="#128945">
          <TotalizadorNum>{totalizadores.totalEntregue}</TotalizadorNum>
          <Divisor borderColor="#128945" />
          <TotalizadorNome>Entregue</TotalizadorNome>
        </Totalizador>
        <Totalizador backgroundColor="#F5F5F5" textColor="#595959">
          <TotalizadorNum>{totalizadores.totalRemovido}</TotalizadorNum>
          <Divisor borderColor="#595959" />
          <TotalizadorNome>Removido</TotalizadorNome>
        </Totalizador>
        <Totalizador backgroundColor="#FFF1F0" textColor="#CF1322">
          <TotalizadorNum>{totalizadores.totalDesistiu}</TotalizadorNum>
          <Divisor borderColor="#CF1322" />
          <TotalizadorNome>Desistiu</TotalizadorNome>
        </Totalizador>
      </>
    )}
    {(!totalizadores || loading) && (
      <LoadingContainer>
        <Spin />
      </LoadingContainer>
    )}
  </Container>
);

export default Totalizadores;

Totalizadores.propTypes = {
  totalizadores: PropTypes.shape({
    totalAguardandoAprovacao: PropTypes.number,
    totalEmTransito: PropTypes.number,
    totalNaFila: PropTypes.number,
    totalEmbarcados: PropTypes.number,
    totalEntregue: PropTypes.number,
    totalRemovido: PropTypes.number,
    totalDesistiu: PropTypes.number,
  }),
  loading: PropTypes.bool,
};

Totalizadores.defaultProps = {
  totalizadores: null,
  loading: false,
};
